import React, { useState } from 'react';
import './Products.css';
import QuoteForm from '../components/QuoteForm';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [quoteFormOpen, setQuoteFormOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');

  const products = [
    // Wire Products
    { id: 1, name: 'BINDING WIRE 18 GAUGE', category: 'wire', image: '/images/products/binding-wire-18.jpeg', description: 'High-quality binding wire for construction and industrial use', applications: ['Construction', 'Sugar mills (bagasse bailing)', 'Textile mills (cotton bailing)', 'Heat treatment plants'] },
    { id: 2, name: 'BINDING WIRE - 20 GAUGE', category: 'wire', image: '/images/products/binding-wire-20.jpg', description: 'Premium binding wire for various applications', applications: ['Construction binding', 'Industrial applications', 'General purpose binding'] },
    { id: 3, name: 'H B WIRE', category: 'wire', image: '/images/products/hb-wire.jpg', description: 'Hard Drawn Bare Wire for industrial applications', applications: ['Cement pipe manufacturing', 'Wire nails production', 'Screws manufacturing', 'Weld mesh production'] },
    { id: 4, name: 'G I WIRE - COMMERCIAL BRAND', category: 'wire', image: '/images/products/gi-wire-commercial.jpg', description: 'Commercial grade galvanized iron wire', applications: ['Vineyards', 'Poultry farms', 'Stitching wire', 'Electric poles', 'Automobile industry'] },
    { id: 5, name: 'TATA BRAND GI WIRE', category: 'wire', image: '/images/products/gi-wire-tata.jpg', description: 'Premium TATA brand galvanized iron wire', applications: ['High-quality fencing', 'Industrial applications', 'Corrosion-resistant applications'] },

    // Fencing Products
    { id: 6, name: 'BARBED WIRE', category: 'fencing', image: '/images/products/barbed-wire.png', description: 'Standard barbed wire for boundary fencing', applications: ['Land boundaries', 'Greenhouses', 'Animal husbandry', 'Plantations', 'Agricultural fencing'] },
    { id: 7, name: 'TATA BARBED WIRE', category: 'fencing', image: '/images/products/barbed-wire-tata.png', description: 'Premium TATA brand barbed wire', applications: ['High-security fencing', 'Commercial boundaries', 'Agricultural applications'] },
    { id: 8, name: 'WELDMESH - GI', category: 'fencing', image: '/images/products/weldmesh-gi.png', description: 'Galvanized welded mesh for security and safety', applications: ['Security fencing', 'Storage applications', 'Agriculture', 'Horticulture', 'Mining'] },
    { id: 9, name: 'WELDMESH - MS', category: 'fencing', image: '/images/products/weldmesh-ms.png', description: 'Mild steel welded mesh for various applications', applications: ['Industrial fencing', 'Safety barriers', 'Construction reinforcement'] },
    { id: 10, name: 'CHAINLINK', category: 'fencing', image: '/images/products/chainlink.png', description: 'Diamond pattern chainlink fencing', applications: ['Residential areas', 'Business complexes', 'Parks', 'Schools', 'Hospitals', 'Railways', 'Airports'] },

    // Structural & Roofing
    { id: 11, name: 'GL GC SHEET', category: 'structural', image: '/images/products/gl-gc-sheet.png', description: 'Galvalume and galvanized corrugated sheets', applications: ['Industrial roofing', 'warehouse construction', 'Factory buildings'] },
    { id: 12, name: 'ROOFING SHEET', category: 'structural', image: '/images/products/roofing-sheet.png', description: 'Corrugated galvanized iron roofing sheets', applications: ['Factories', 'Warehouses', 'Garages', 'Labs', 'Mills', 'Supermarkets', 'Offices', 'Showrooms'] },
    { id: 13, name: 'TMT BAR', category: 'structural', image: '/images/products/tmt-bar.png', description: 'Fe500 TMT Steel Bars for construction', applications: ['Building construction', 'Infrastructure projects', 'Reinforcement work'] },
    { id: 14, name: 'STRUCTURAL STEEL', category: 'structural', image: '/images/products/structural-steel.png', description: 'Complete range of structural steel products', applications: ['Power plants', 'Industrial sheds', 'Warehouses', 'High-rise buildings', 'Metro stations', 'Cold storages'] }
  ];

  const categories = [
    { id: 'all', name: 'All Products', icon: '📦' },
    { id: 'wire', name: 'Wire Products', icon: '🧵' },
    { id: 'fencing', name: 'Fencing Products', icon: '🛡' },
    { id: 'structural', name: 'Structural & Roofing', icon: '🏗' }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  const handleGetQuote = (productName) => {
    setSelectedProduct(productName);
    setQuoteFormOpen(true);
  };

  const closeQuoteForm = () => {
    setQuoteFormOpen(false);
    setSelectedProduct('');
  };

  return (
    <div className="products">
      {/* Hero Section */}
      <section className="products-hero">
        <div className="container">
          <h1>Our Products</h1>
          <p>Complete range of wire, fencing, and structural steel products</p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="category-filter">
        <div className="container">
          <div className="filter-buttons">
            {categories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.icon} {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="products-grid">
        <div className="container">
          <div className="grid">
            {filteredProducts.map(product => (
              <div key={product.id} className="product-card">
                <div className="product-image">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    onError={(e) => {
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y4ZmFmYyIvPgogIDx0ZXh0IHg9IjE1MCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM2Mzc0OGIiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIwLjNlbSI+UHJvZHVjdCBJbWFnZTwvdGV4dD4KPC9zdmc+';
                    }}
                  />
                </div>
                <div className="product-header">
                  <h3>{product.name}</h3>
                  <span className={`category-badge ${product.category}`}>
                    {categories.find(cat => cat.id === product.category)?.icon}
                  </span>
                </div>
                
                <p className="product-description">{product.description}</p>
                
                <div className="applications">
                  <h4>Applications:</h4>
                  <ul>
                    {product.applications.map((app, index) => (
                      <li key={index}>✓ {app}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="product-footer">
                  <button 
                    className="inquiry-btn"
                    onClick={() => handleGetQuote(product.name)}
                  >
                    📞 Get Quote
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Product Categories Overview */}
      <section className="categories-overview">
        <div className="container">
          <h2>Product Categories</h2>
          <div className="categories-grid">
            <div className="category-card">
              <div className="category-icon">🧵</div>
              <h3>Wire Products</h3>
              <p>MS Binding Wire, GI Wire, HB Wire, SS Wire, PC Wire, Cutting Wire, Wire Rod</p>
              <ul>
                <li>• 18 & 20 Gauge Binding Wire</li>
                <li>• Commercial & TATA Brand GI Wire</li>
                <li>• Hard Drawn Bare Wire</li>
              </ul>
            </div>
            
            <div className="category-card">
              <div className="category-icon">🛡</div>
              <h3>Fencing Products</h3>
              <p>Chainlink, Barbed Wire, Weldmesh, Concertina Coil, 3D Fence, Knotted Fence, PVC Wires</p>
              <ul>
                <li>• Standard & TATA Barbed Wire</li>
                <li>• GI & MS Weldmesh</li>
                <li>• Chainlink Fencing</li>
              </ul>
            </div>
            
            <div className="category-card">
              <div className="category-icon">🏗</div>
              <h3>Structural Steel</h3>
              <p>Channel, Angle, Pipe, Plate, Beam, Colour Sheets, TMT Bars</p>
              <ul>
                <li>• TMT Bars Fe500</li>
                <li>• Roofing Sheets (All Colors)</li>
                <li>• Complete Structural Range</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Partners */}
      <section className="brand-partners">
        <div className="container">
          <h2>Trusted Brand Partners</h2>
          <div className="brands">
            <div className="brand">🏭 TATA</div>
            <div className="brand">🏭 ESSAR</div>
            <div className="brand">🏭 BHUSHAN</div>
            <div className="brand">🏭 JSW</div>
          </div>
          <p>We partner with industry-leading brands to ensure premium quality products</p>
        </div>
      </section>

      {/* Contact for Inquiry */}
      <section className="product-inquiry">
        <div className="container">
          <h2>Need a Custom Quote?</h2>
          <p>Contact us for pricing, bulk orders, or custom requirements</p>
          <div className="inquiry-contact">
            <div className="contact-method">
              <h3>📞 Kolhapur Contact</h3>
              <a href="tel:+919404257415" className="contact-link">+91 9404257415</a>
            </div>
            <div className="contact-method">
              <h3>📍 Kolhapur Office</h3>
              <p>Plot no D-55, Gokulshirgaon MIDC<br />Kolhapur - 416234</p>
              <a
                href="https://maps.app.goo.gl/VWbetrScSxLM1apA6?g_st=aw"
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps
              </a>
            </div>
            <div className="contact-method">
              <h3>📞 Pune Contact</h3>
              <a href="tel:+919372937239" className="contact-link">+91 9372937239</a>
            </div>
            <div className="contact-method">
              <h3>📍 Pune Office</h3>
              <p>6/1/1, Near Bazare Petrol Pump, Uruli Devachi,<br />Handewadi-Katraj Road, Pune - 412308</p>
              <a
                href="https://maps.app.goo.gl/RV39i8TFpzn1dxGW9?g_st=aw"
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form Modal */}
      <QuoteForm 
        isOpen={quoteFormOpen}
        onClose={closeQuoteForm}
        productName={selectedProduct}
      />
    </div>
  );
};

export default Products;